import { useState } from 'react';
import { Control, useController } from 'react-hook-form';
import './CheckboxListInput.scss';

export interface CheckboxChoice {
    value: number;
    title: string;
    meta?: string;
}

interface CheckboxListInputProps {
    name: string;
    control: Control<any>;
    choices: CheckboxChoice[];
    label?: string;
    searchPlaceholder?: string;
    onSearch?: (query: string) => void;
}

export function CheckboxListInput({
    name,
    control,
    choices,
    label,
    searchPlaceholder = 'Поиск...',
    onSearch,
}: CheckboxListInputProps) {
    const { field } = useController({ name, control });
    const selected: number[] = field.value ?? [];

    const [search, setSearch] = useState('');

    const filtered = onSearch
        ? choices
        : choices.filter(c => c.title.toLowerCase().includes(search.toLowerCase()));

    const toggle = (value: number) => {
        const next = selected.includes(value)
            ? selected.filter(v => v !== value)
            : [...selected, value];
        field.onChange(next);
    };

    return (
        <div className="CheckboxListInput">
            {label && <label className="CheckboxListInput__label">{label}</label>}
            <input
                className="CheckboxListInput__search"
                placeholder={searchPlaceholder}
                value={search}
                onChange={e => {
                    setSearch(e.target.value);
                    onSearch?.(e.target.value);
                }}
            />
            <div className="CheckboxListInput__list">
                {filtered.length === 0 ? (
                    <div className="CheckboxListInput__empty">Ничего не найдено</div>
                ) : (
                    filtered.map(choice => {
                        const checked = selected.includes(choice.value);
                        return (
                            <label
                                key={choice.value}
                                className={`CheckboxListInput__item${checked ? ' CheckboxListInput__item--checked' : ''}`}
                            >
                                <input
                                    type="checkbox"
                                    className="CheckboxListInput__checkbox"
                                    checked={checked}
                                    onChange={() => toggle(choice.value)}
                                />
                                <span className="CheckboxListInput__title">{choice.title}</span>
                                {choice.meta && (
                                    <span className="CheckboxListInput__badge">{choice.meta}</span>
                                )}
                            </label>
                        );
                    })
                )}
            </div>
            <span className="CheckboxListInput__footer">
                Выбрано: {selected.length} из {choices.length}
            </span>
        </div>
    );
}
